<template>
  <div v-show="abrir" class="modal-preview-html-overlay" @click.self="fechar">
      <div class="modal-preview-html-box">
        <div class="modal-preview-html-header">
          <h5 class="modal-preview-html-title">Visualizar conteúdo HTML</h5>
          <button type="button" class="btn-close" @click="fechar" aria-label="Fechar"></button>
        </div>
        <div class="modal-preview-html-body">
          <div class="row">
            <div class="col-6">
              <h3 class="text-center">Modo Claro</h3>
              <div class="preview-version preview-light">
                <HtmlEditorContent :content="content" theme="light" />
              </div>
            </div>
            <div class="col-6">
              <h3 class="text-center">Modo Escuro</h3>
              <div class="preview-version preview-dark dark-mode">
                <HtmlEditorContent :content="content" theme="dark" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-preview-html-footer pe-4">
          <button type="button" class="btn btn-cancel pull-end" @click="fechar">
            Fechar
          </button>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ModalPreviewHtmlContent',
  props: {
    abrir: {
      type: Boolean,
      default: false,
    },
    /** Conteúdo HTML do v-model do editor (duplicado nas duas colunas). */
    content: {
      type: String,
      default: '',
    },
  },
  emits: ['fechar'],
  methods: {
    fechar() {
      this.$emit('fechar');
    },
  },
};
</script>

<style scoped>
/* Overlay acima do modal Bootstrap (z-index 1050) para não fechar o modal por baixo */
.modal-preview-html-overlay {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 32px;
}

.modal-preview-html-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: calc(100vw - 64px);
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  background: var(--bs-body-bg, #fff);
  border-radius: 0.3rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.modal-preview-html-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid var(--bs-border-color, #dee2e6);
  flex-shrink: 0;
}

.modal-preview-html-title {
  margin: 0;
  font-size: 1.25rem;
}

.modal-preview-html-body {
  padding: 1rem;
  overflow: auto;
  flex: 1;
}

.modal-preview-html-footer {
  padding: 1rem;
  border-top: 1px solid var(--bs-border-color, #dee2e6);
  flex-shrink: 0;
}

/* Placeholder para futuras versões light/dark do CSS do conteúdo */
.preview-version {
  min-height: 120px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none;
}

.preview-version :deep(*) {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none;
}

.preview-light {
  border: 1px solid #e3e3e3;
  padding: 6px;
  background-color: #ffffff;
}

.preview-dark {
  border: 1px solid #e3e3e3;
  padding: 6px;
  background-color: #33333c;
}
</style>
